import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { GeneralResponse } from "../../../types/api";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import { IForgetPasswordResendOTPCodeRequest } from "../../../types/apis/auth-apis";

export const ForgetPasswordResendOTPCode = async (
  payload: IForgetPasswordResendOTPCodeRequest,
): Promise<GeneralResponse> => {
  try {
    const response = await Api<
      any,
      GeneralResponse<IForgetPasswordResendOTPCodeRequest>
    >({
      method: Methods.POST,
      endpoint: EndPoints.forgetPasswordResendCode,
      body: payload,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useForgetPasswordResendOTP = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    IForgetPasswordResendOTPCodeRequest
  > = useMutation({
    mutationFn: ForgetPasswordResendOTPCode,
    ...options,
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
